import { AppThunk } from '../../../store/rootReducer';
import { roundedDurationSelector } from '../../ecg/selectors/ecg.selectors';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Tool } from '../../tool/utils/tool.utils';
import * as episodeMeasurementActions from '../actions/episode-measurement.actions';
import {
  episodeMeasurementRangeSelector,
  isMovingEpisodeMeasurementSelector,
  isUpdatingEpisodeMeasurementSelector,
  previousEpisodeMeasurementTimestampSelector,
} from '../selectors/episode-measurement.selectors';

export const setEpisodeMeasurementTimestamp =
  (timestamp: number): AppThunk =>
  async (dispatch, getState) => {
    const isUpdatingEpisodeMeasurement = isUpdatingEpisodeMeasurementSelector(
      getState(),
    );
    const isEpisodeMeasurementActive = isToolActiveSelector(
      Tool.episodeMeasurement,
    )(getState());
    const [start, end] = episodeMeasurementRangeSelector(getState());
    const duration = roundedDurationSelector(getState());
    const prevTimestamp = previousEpisodeMeasurementTimestampSelector(
      getState(),
    );
    const isMoving = isMovingEpisodeMeasurementSelector(getState());
    let newTimestamp = timestamp;

    if (isMoving && start - (prevTimestamp - timestamp) < 0) {
      newTimestamp = prevTimestamp - start;
    } else if (isMoving && end - (prevTimestamp - timestamp) > duration) {
      newTimestamp = duration + prevTimestamp - end - 40;
    }

    if (isUpdatingEpisodeMeasurement && isEpisodeMeasurementActive) {
      dispatch(
        episodeMeasurementActions.setTimestamp({
          timestamp: newTimestamp,
          meta: { history: false },
        }),
      );
    }
  };
